<template>
  <div>
    <div class="modelReg__title">
      <h3>{{ $t('modal.modalStateEnum.ChangePasswordSuccessfully.title') }}</h3>
      <p>
        {{ $t('modal.modalStateEnum.ChangePasswordSuccessfully.subTitle') }}
      </p>
    </div>
    <div class="modelReg__btn">
      <UiBaseButton class="btn" size="xxl" :label="$t('logout')" @click="logIn"></UiBaseButton>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { modalStateEnum } from '@shared/model';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();

const logIn = () => {
  storeModal.stateAuthModal(modalStateEnum.login);
};
</script>


